import type { Notification, UploadNotificationMetadata } from '@types'
import axios from 'axios'

import env from '../environments'

export async function getNotifications() {
	const response = await axios.get(`${env.apiUrl}/notifications`)

	return response.data as Notification[]
}

export async function getNotification(notificationId: string) {
	const response = await axios.get(`${env.apiUrl}/notifications/${notificationId}`)

	return response.data as Notification
}

export async function createNotification(notification: Partial<Notification>) {
	const response = await axios.post(`${env.apiUrl}/notifications`, notification)

	return response.data as Notification
}

export async function atomicNotificationContentUpdate(notificationId: string, content: UploadNotificationMetadata['contentList'][0]) {
	const response = await axios.put(`${env.apiUrl}/notifications/atomic/${notificationId}`, content)

	return response.data as Notification
}

export async function updateNotification(notification: Partial<Notification> & {id: string}) {
	const response = await axios.put(`${env.apiUrl}/notifications/${notification.id}`, notification)

	return response.data as Notification
}

export async function deleteNotification(notificationId: string) {
	await axios.delete(`${env.apiUrl}/notifications/${notificationId}`)
}

export async function clearAllNotifications() {
	await axios.delete(`${env.apiUrl}/notifications/all`)
}
